import { trackEvent } from '../../../utils/analytics';

export default function FooterSection() {
  return (
    <footer className="bg-[#0D0D0D] border-t border-white/8 py-14">
      <div className="max-w-7xl mx-auto px-5 md:px-10">

        <div className="flex flex-col lg:flex-row items-start justify-between gap-8 pb-10 border-b border-white/8">

          {/* Brand */}
          <div className="max-w-xs">
            <img
              src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/81e3031b4bcc562bb081a6ae4aa9af2c.png"
              alt="Punto Cassonetti – Logo ufficiale produttori cassonetti PVC e controtelai termici Made in Italy"
              title="Punto Cassonetti srls – Produttori cassonetti PVC e controtelai termici Lombardia Veneto Emilia Romagna"
              className="h-9 w-auto object-contain mb-3"
            />
            <p className="text-white/40 text-xs leading-relaxed mb-3" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              Produttori di cassonetti PVC e controtelai termici 100% Made in Italy. Produzione su misura 48h.
            </p>
            <div className="inline-flex items-center gap-2 bg-[#7FCDCD]/10 border border-[#7FCDCD]/20 rounded-lg px-3 py-1.5">
              <i className="ri-award-fill text-[#7FCDCD] text-xs"></i>
              <span className="text-[#7FCDCD] text-xs font-semibold">U<sub>sb</sub> = 1 W/m²K</span>
            </div>
          </div>

          {/* Links grid on mobile — 2 col */}
          <div className="grid grid-cols-2 lg:flex lg:flex-row gap-8 lg:gap-12 w-full lg:w-auto">

            {/* Prodotti */}
            <div>
              <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-4" style={{ fontFamily: "'Raleway', sans-serif" }}>Prodotti</h4>
              <div className="space-y-2">
                {['Cassonetti in PVC','Cassonetto EVO 150','Cassonetto Rehau','Controtelai','Termiko®','Monoblocco'].map((pp) => (
                  <a key={pp} href="#prodotti" className="block text-white/40 hover:text-white transition-colors text-xs cursor-pointer">{pp}</a>
                ))}
              </div>
            </div>

            {/* Contatti */}
            <div>
              <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-4" style={{ fontFamily: "'Raleway', sans-serif" }}>Contatti</h4>
              <div className="space-y-2.5">
                <a
                  href="tel:+390519981801"
                  onClick={() => trackEvent('phone_click', '051 9981801 – footer', 'footer')}
                  className="flex items-center gap-2 text-white/40 hover:text-white transition-colors text-xs cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-[#7FCDCD]"></i> 051 9981801
                </a>
                <a
                  href="tel:+393939932439"
                  onClick={() => trackEvent('phone_click', '+39 393 993 2439 – footer', 'footer')}
                  className="flex items-center gap-2 text-white/40 hover:text-white transition-colors text-xs cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-[#7FCDCD]"></i> +39 393 993 2439
                </a>
                <a href="mailto:puntocassonetti@gmail.com" className="flex items-center gap-2 text-white/40 hover:text-white transition-colors text-xs cursor-pointer">
                  <i className="ri-mail-fill text-[#7FCDCD]"></i> Email
                </a>
                <a
                  href="https://wa.me/393939932439"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  onClick={() => trackEvent('whatsapp_click', 'WhatsApp – footer', 'footer')}
                  className="flex items-center gap-2 text-white/40 hover:text-green-400 transition-colors text-xs cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-green-500"></i> WhatsApp
                </a>
              </div>
            </div>

            {/* Sede */}
            <div>
              <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-4" style={{ fontFamily: "'Raleway', sans-serif" }}>Sede</h4>
              <div className="flex items-start gap-2 text-white/40 text-xs mb-3">
                <i className="ri-map-pin-2-fill text-[#7FCDCD] mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-white/70 font-semibold mb-1">Punto Cassonetti srls</p>
                  <p>Via dei Lapidari, 15</p>
                  <p>40129 Bologna (BO)</p>
                </div>
              </div>
              <a
                href="https://www.google.com/maps/place/Via+dei+Lapidari,+15,+40129+Bologna"
                target="_blank" rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-white/40 border border-white/15 px-3 py-1.5 rounded-md hover:border-[#7FCDCD]/50 hover:text-[#7FCDCD] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-2-line"></i> Google Maps
              </a>
            </div>

            {/* CTA */}
            <div>
              <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-4" style={{ fontFamily: "'Raleway', sans-serif" }}>Preventivo rapido</h4>
              <div className="space-y-2.5">
                <a href="#form" className="flex items-center justify-center gap-2 bg-[#7FCDCD] hover:bg-[#6bbaba] text-white text-xs font-bold py-3 px-4 rounded-md transition-colors whitespace-nowrap cursor-pointer">
                  Richiedi preventivo
                </a>
                <a
                  href="https://wa.me/393939932439"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  onClick={() => trackEvent('whatsapp_click', 'WhatsApp CTA – footer', 'footer')}
                  className="flex items-center justify-center gap-2 bg-green-600/80 hover:bg-green-600 text-white text-xs font-bold py-3 px-4 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line"></i> WhatsApp diretto
                </a>
              </div>
            </div>

          </div>
        </div>

        <div className="pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">
            © {new Date().getFullYear()} Punto Cassonetti srls · P. IVA 03935951206 · Bologna · Lombardia · Veneto · Emilia Romagna
          </p>
          <div className="flex items-center gap-5">
            <a href="https://www.puntocassonetti.it/privacy-policy/" target="_blank" rel="noopener noreferrer nofollow" className="text-white/25 hover:text-white/50 text-xs transition-colors whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="https://www.puntocassonetti.it/normativa-cookies/" target="_blank" rel="noopener noreferrer nofollow" className="text-white/25 hover:text-white/50 text-xs transition-colors whitespace-nowrap">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
